<template>
  <van-popup :style="{ height: '100%', width: '100%' }" :overlay="false" v-model="show" @close="onClosePopup">
    <form class="city-form" action="/">
      <van-search v-model="value" right-icon="" show-action placeholder="请输入城市名" @input="onCityEnter">
        <template #left-icon>
          <div v-if="cityShow">
            <van-icon name="search" />
          </div>
        </template>
        <template #action>
          <div @click="onCityCanel">取消</div>
        </template>
      </van-search>
      <div class="city-blong">所属医院位置</div>
      <div class="city-true-blong">
        <img class="city-true-blong-img" src="../../../assets/images/application-study/loaction.png" alt="" />
        {{ trueCity == '' ? '无' : trueCity }}
      </div>
    </form>
    <div :class="bindCityStatus == 1 ? 'bind-city' : 'bind-citys'">
      <div class="search-bottom-citys" v-for="item in cityList" :key="item.johnsonCityCode" @click="onClickCity(item)">
        <div class="search-bottom-citys-title">{{ item.cityName }}</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'Location',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    trueCityParam: {
      type: String,
      default: ''
    },
    bindCityStatusParam: {
      type: Number,
      default: 1
    },
    cityListParam: {
      type: Array,
      default: () => {
        return []
      }
    },
    cityShowParam: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      trueCity: '',
      bindCityStatus: 1,
      cityList: [],
      value: '',
      cityShow: true
    }
  },
  watch: {
    isShow: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.show = newValue
        }
      },
      deep: true // 深度监听
      //   immediate: true
    },
    trueCityParam: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.trueCity = newValue
        }
      },
      deep: true // 深度监听
      //   immediate: true
    },
    bindCityStatusParam: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.bindCityStatus = newValue
        }
      },
      deep: true // 深度监听
      //   immediate: true
    },
    cityListParam: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.cityList = newValue
        }
      },
      deep: true // 深度监听
      //   immediate: true
    },
    cityShowParam: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.cityShow = newValue
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    // 城市列表点击取消时触发
    onCityCanel() {
      this.show = false
      this.$emit('onCityCanel')
    },
    // 城市搜索输入框内容变化时触发
    onCityEnter(value) {
      this.$emit('onCityEnter', value)
    },
    // 点击列表城市触发
    onClickCity(value) {
      this.show = false
      this.$emit('onClickCity', value)
    },
    onClosePopup() {
      this.show = false
      this.$emit('onClosePopup')
    }
  }
}
</script>

<style lang="less" scoped>
// 城市搜索置顶部分
.city-form {
  width: 100%;
  // height: 80px;
  position: fixed;
  top: 0;
  // 城市搜索置顶部分文字
  .city-blong {
    margin-top: 12px;
    margin-left: 14px;
    font-size: 11px;
    font-weight: 500;
    color: #666666;
  }
  // 城市搜索置顶部分图标
  .city-true-blong {
    font-size: 14px;
    font-weight: bold;
    color: #1f333f;
    margin: 16px 14px 0 14px;
    // 城市搜索置顶部分图标文字
    .city-true-blong-img {
      width: 11px;
      height: 10px;
      display: inline-block;
      margin-right: 6px;
    }
  }
  // 城市搜索置顶部分搜索框样式
  /deep/ .van-search {
    padding-top: 14px;
    padding-bottom: 0px;
  }
}
// 城市搜索下拉列表
.bind-city {
  margin-top: 110px;
  .search-bottom-citys {
    margin: 0 14px;
    padding: 16px 0px;
    border-bottom: 1px solid #eeeeee;
    .search-bottom-citys-title {
      height: 14px;
      font-size: 14px;
      font-weight: 500;
      color: #1f333f;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/application-study/components/location.vue